import "./App.css";
import ScrollToTop from "./ScrollToTop";
import { UserProvider } from "./Components/Context/UserContext";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ElevenlabAgent } from "./Components/ElevenlabAgent";

// Common Components
import { Footer } from "./Components/Footer";
import { Header } from "./Components/Header";
import { Home } from "./Components/Home";
import { Login } from "./Components/Login";

// Page Components
import { Service } from "./Components/Pages/Service";
import { Blog } from "./Components/Pages/Blog";
import { ContactUs } from "./Components/Pages/Contactus";
import { BookDemo } from "./Components/Pages/BookDemo";

// Blog Detail Components
import { Digital } from "./Components/Pages/Blogs/Digital-Detail";
import { Blog2 } from "./Components/Pages/Blogs/Blog-2";
import { Blog3 } from "./Components/Pages/Blogs/Blog-3";
import { Blog4 } from "./Components/Pages/Blogs/Blog-4";
// Terms and Conditions Component
import TermsAndConditions from "./Components/Pages/Terms&Conditions/Terms&Conditions";
// Privacy and Policy Component
import PrivacyAndPolicy from "./Components/Pages/Privacy&Policy/Privacy&Policy";
// Password Reset Components
import { Reset } from "./Components/Pages/Password Reset/Reset-Password";
import { Otp } from "./Components/Pages/Password Reset/Otp";

// Management Components
import { Management } from "./Management/Management";
import { NewCompanyProfile } from "./Management/NewCompanyProfile";
// GoogleSheetsConfig removed (Google Sheets integration retired)

// Admin Components
import { Alogin } from "../src/Amc/alogin";
import { AdminDashboard } from "./Amc/AdminDashboard";
import SubscribeService from "./Management/SubscribeService";
import CheckoutPage from "./Components/Payment/CheckoutPage";
 
import PaymentSuccess from "./Components/Payment/PaymentSuccess";
import PaymentCancel from "./Components/Payment/PaymentCancel";

/**
 * Main content component that renders the application layout
 * Handles conditional rendering of header/footer based on current route
 */
function AppContent() {
  const location = useLocation();

  // Routes where header and footer should be hidden
  const hideHeaderFooter =
    location.pathname.startsWith("/management") ||
    location.pathname.startsWith("/new-company") ||
    // google-sheets-config route removed
    location.pathname.startsWith("/admin/dashboard") ||
    location.pathname.startsWith("/admin/login");

  return (
    <div className="container">
      {/* ElevenLabs AI Agent Widget */}
      <ElevenlabAgent />
      
      {/* Conditionally render header if not on management/admin routes */}
      {!hideHeaderFooter && <Header />}

      {/* Scroll to top functionality */}
      <ScrollToTop />

      {/* Main application routes */}
      <Routes>
        {/* Public routes */}
        <Route index element={<Home />} />
        <Route path="/service" element={<Service />} />
        <Route path="/book-demo" element={<BookDemo />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<ContactUs />} />

        {/* Blog detail routes */}
        <Route path="/digital" element={<Digital />} />
        <Route path="/blog2" element={<Blog2 />} />
        <Route path="/blog3" element={<Blog3 />} />
        <Route path="/blog4" element={<Blog4 />} />
        {/* Privacy & Policy  */}
        <Route path="/privacy-policy" element={<PrivacyAndPolicy />} />
        {/* Terms & Conditions */}
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        {/* Authentication routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<Reset />} />
        <Route path="/otp" element={<Otp />} />
        {/*Checkout Components */}
        <Route path="/company" element={<SubscribeService />} />
        <Route path="/checkout" element={<CheckoutPage/>} />
        {/* Payment Routes */}
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        {/* Management routes */}
        <Route path="/management" element={<Management />} />
        <Route path="/new-company" element={<NewCompanyProfile />} />
        {/* Google Sheets config route removed */}

        {/* Admin routes */}
        <Route path="/admin/login" element={<Alogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>

      {/* Conditionally render footer if not on management/admin routes */}
      {!hideHeaderFooter && <Footer />}
    </div>
  );
}
/**
 * Main App component that wraps the entire application
 * Provides user context and routing configuration
 */
function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
